/**
 * @fileoverview GET handler for the "/data_objects/data_object_type_attributes" endpoint.
 * Returns the filterable attributes for a custom object type.
 */
import fetch from "@lib/fetch";

import { buildCustomObjectsQueryParams } from "../customObjectsShared/buildQueryParams";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { customObjectsCustomObjectTypeAttributes } from "./constants";
import type {
  GetCustomObjectsCustomObjectTypeAttributesParams,
  GetCustomObjectsCustomObjectTypeAttributesResult,
} from "./types";
import { isGetCustomObjectsCustomObjectTypeAttributesResult } from "./validators";

export const getCustomObjectsCustomObjectTypeAttributes = reactQueryFetcherAdapter(
  customObjectsCustomObjectTypeAttributes,
  (
    signal: AbortSignal,
    params: GetCustomObjectsCustomObjectTypeAttributesParams
  ): Promise<GetCustomObjectsCustomObjectTypeAttributesResult> => {
    return fetch(
      "/data_objects/data_object_type_attributes",
      "GET",
      buildCustomObjectsQueryParams(params),
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCustomObjectsCustomObjectTypeAttributesResult
);
